import { render, staticRenderFns } from "./lateArrivalPenaltyExcludeAdd.vue?vue&type=template&id=72a39d00&scoped=true&"
import script from "./lateArrivalPenaltyExcludeAdd.vue?vue&type=script&lang=js&"
export * from "./lateArrivalPenaltyExcludeAdd.vue?vue&type=script&lang=js&"
import style0 from "./lateArrivalPenaltyExcludeAdd.vue?vue&type=style&index=0&id=72a39d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a39d00",
  null
  
)

export default component.exports